import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  class: "dataForm",
  style: {"min-width":"800px"}
}
const _hoisted_2 = { class: "underlineForm" }
const _hoisted_3 = {
  key: 0,
  class: "dialog-footer mt-20"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_form, {
      ref: el => _ctx.dataForm[0] = el,
      model: _ctx.ruleForm,
      rules: _ctx.rules,
      "label-position": "top",
      "label-width": "100px",
      class: "mb-20"
    }, {
      default: _withCtx(() => [
        _renderSlot(_ctx.$slots, "baseInfo"),
        _cache[20] || (_cache[20] = _createElementVNode("div", { class: "form-title mb-10" }, [
          _createElementVNode("span", { class: "label blue" }, "基"),
          _createElementVNode("span", { class: "left" }, "基本信息")
        ], -1)),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_el_form_item, {
            label: "快递公司",
            prop: "expressId"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                filterable: true,
                modelValue: _ctx.ruleForm.expressId,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.ruleForm.expressId) = $event)),
                class: "filter-item",
                placeholder: "输入关键字搜索",
                clearable: "",
                remote: "",
                onFocus: _cache[1] || (_cache[1] = ($event: any) => (_ctx.expressRemoteMethod(''))),
                "remote-method": query => _ctx.expressRemoteMethod(query)
              }, {
                default: _withCtx(() => [
                  (_ctx.expressOption.length)
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.expressOption, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item.id,
                          label: item.name,
                          value: item.id
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    : (_openBlock(), _createBlock(_component_el_option, {
                        key: 1,
                        value: -1,
                        disabled: ""
                      }, {
                        default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                          _createTextVNode("暂无数据", -1)
                        ]))]),
                        _: 1
                      }))
                ]),
                _: 1
              }, 8, ["modelValue", "remote-method"])
            ]),
            _: 1
          }),
          (_ctx.sendFlag === 1)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createVNode(_component_el_form_item, {
                  label: "API自动化",
                  prop: "automation"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      filterable: true,
                      modelValue: _ctx.ruleForm.automation,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.ruleForm.automation) = $event)),
                      class: "filter-item",
                      placeholder: "输入关键字搜索",
                      clearable: ""
                    }, {
                      default: _withCtx(() => [
                        (_ctx.automationOption.length)
                          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.automationOption, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.id,
                                label: item.mark,
                                value: item.id
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          : (_openBlock(), _createBlock(_component_el_option, {
                              key: 1,
                              value: -1,
                              disabled: ""
                            }, {
                              default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                                _createTextVNode("暂无数据", -1)
                              ]))]),
                              _: 1
                            }))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                (_ctx.ruleForm.automation)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createVNode(_component_el_form_item, {
                        label: "发货人信息",
                        prop: "shipperInfoId"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            filterable: true,
                            modelValue: _ctx.ruleForm.shipperInfoId,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.ruleForm.shipperInfoId) = $event)),
                            class: "filter-item",
                            placeholder: "输入关键字搜索",
                            clearable: "",
                            remote: "",
                            "remote-method": _ctx.getShipperOptionRemote,
                            onFocus: _cache[4] || (_cache[4] = ($event: any) => (_ctx.getShipperOptionRemote('')))
                          }, {
                            default: _withCtx(() => [
                              (_ctx.shipperOption.length)
                                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.shipperOption, (item) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: item.id,
                                      label: item.name,
                                      value: item.id
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                : (_openBlock(), _createBlock(_component_el_option, {
                                    key: 1,
                                    value: -1,
                                    disabled: ""
                                  }, {
                                    default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                                      _createTextVNode("暂无数据", -1)
                                    ]))]),
                                    _: 1
                                  }))
                            ]),
                            _: 1
                          }, 8, ["modelValue", "remote-method"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        label: "保价",
                        prop: "insure"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.ruleForm.insure,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.ruleForm.insure) = $event)),
                            type: "input",
                            class: "filter-item"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ], 64))
                  : _createCommentVNode("", true)
              ], 64))
            : _createCommentVNode("", true),
          _createVNode(_component_el_form_item, {
            label: "物品类型",
            prop: "type"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                filterable: true,
                modelValue: _ctx.ruleForm.type,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.ruleForm.type) = $event)),
                class: "filter-item",
                placeholder: "输入关键字搜索",
                clearable: ""
              }, {
                default: _withCtx(() => [
                  (_ctx.typesOption.length)
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.typesOption, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item.id,
                          label: item.mark,
                          value: item.id
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    : (_openBlock(), _createBlock(_component_el_option, {
                        key: 1,
                        value: -1,
                        disabled: ""
                      }, {
                        default: _withCtx(() => [...(_cache[18] || (_cache[18] = [
                          _createTextVNode("暂无数据", -1)
                        ]))]),
                        _: 1
                      }))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "快递单号",
            prop: "expressNo"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.ruleForm.expressNo,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.ruleForm.expressNo) = $event)),
                type: "input",
                class: "filter-item"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "物品名称",
            prop: "goods"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.ruleForm.goods,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.ruleForm.goods) = $event)),
                type: "input",
                class: "filter-item"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: _ctx.sendFlag === 1 ? '发件人' : '收件人',
            prop: "contact"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                filterable: true,
                modelValue: _ctx.ruleForm.contact,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.ruleForm.contact) = $event)),
                class: "filter-item",
                placeholder: "输入关键字搜索",
                clearable: "",
                onFocus: _cache[10] || (_cache[10] = ($event: any) => (_ctx.getUserOptionRemote('')))
              }, {
                default: _withCtx(() => [
                  (_ctx.userOption.length)
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.userOption, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item.id,
                          label: item.mark,
                          value: item.id
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    : (_openBlock(), _createBlock(_component_el_option, {
                        key: 1,
                        value: -1,
                        disabled: ""
                      }, {
                        default: _withCtx(() => [...(_cache[19] || (_cache[19] = [
                          _createTextVNode("暂无数据", -1)
                        ]))]),
                        _: 1
                      }))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_form_item, {
            label: _ctx.sendFlag === 1 ? '发件人号码' : '收件人号码',
            prop: "phone"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.ruleForm.phone,
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.ruleForm.phone) = $event)),
                type: "input",
                class: "filter-item"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_form_item, {
            label: "省市县",
            prop: "place"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.ruleForm.place,
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.ruleForm.place) = $event)),
                type: "input",
                class: "filter-item"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "详细地址",
            prop: "placeDetail"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.ruleForm.placeDetail,
                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.ruleForm.placeDetail) = $event)),
                type: "input",
                class: "filter-item"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "备注",
            prop: "mark",
            class: "fullWidth"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.ruleForm.mark,
                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.ruleForm.mark) = $event)),
                type: "textarea",
                class: "filter-item",
                clearable: ""
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          })
        ])
      ]),
      _: 3
    }, 8, ["model", "rules"]),
    (_ctx.mode !== 'approval')
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_component_el_button, { onClick: _ctx.cancle }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t("table.cancel")), 1)
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_el_button, {
            type: "primary",
            loading: _ctx.submitLoading,
            onClick: _ctx.handleSubmit
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t("table.confirm")), 1)
            ]),
            _: 1
          }, 8, ["loading", "onClick"])
        ]))
      : _createCommentVNode("", true)
  ]))
}